export class IdTarget {
  value: string

  constructor() {
    this.value = (Math.random() * 10**8).toString(16);
  }
}
